module.exports = __webpack_public_path__ + "static/media/zhe-fruit.47153197.png";